import {action, observable, runInAction, makeObservable} from 'mobx';
import browserLang from "browser-lang";
import {decorate, inject, injectable} from '@yosmanyga/di';
import {Dispatcher, LanguageManager} from '@yosmanyga/base';

class AppLanguageController {
    loaded: boolean;
    language: string | null;

    constructor(
        private dispatcher: Dispatcher,
        private languageManager: LanguageManager
    ) {
        this.loaded = false;
        this.language = null;

        this.dispatcher.register('language_deleted', this.listenToLanguageDeleted)

        makeObservable(this, {
            loaded: observable,
        });
    }

    load = async () => {
        await this.languageManager.load();

        let language = this.languageManager.get();

        if (!language) {
            let pref;
            
            try {
                // TODO: Implement mobile language detection
                pref = browserLang({
                    languages: ['en', 'es'],
                    fallback: 'en',
                });
            } catch (e) {
                pref = 'en';
            }

            await this.languageManager.save(pref);
            language = pref;
        }

        runInAction(() => {
            this.language = language;
            this.loaded = true;
        });
    };

    set = async (language: string) => {
        await this.languageManager.save(language);

        runInAction(() => {
            this.language = language;
        });
    };

    listenToLanguageDeleted = () => {
        runInAction(() => {
            this.language = null;
        });
    }
}

decorate(injectable(), AppLanguageController);
decorate(inject(Dispatcher), AppLanguageController, 0);
decorate(inject(LanguageManager), AppLanguageController, 1);

export {AppLanguageController};
